import React from "react";
import { Spinner } from "react-bootstrap";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";

interface IProps {
  verificationCode: string[];
  codeInputRefs: React.MutableRefObject<(HTMLInputElement | null)[]>;
  isVerifying: boolean;
  onCodeChange: (index: number, value: string) => void;
  onCodeKeyDown: (index: number, e: React.KeyboardEvent<HTMLInputElement>) => void;
  onCodePaste: (e: React.ClipboardEvent) => void;
  onVerifyCode: () => void;
}

const CpntCodeVerification: React.FC<IProps> = ({
  verificationCode,
  codeInputRefs,
  isVerifying,
  onCodeChange,
  onCodeKeyDown,
  onCodePaste,
  onVerifyCode,
}) => {
  return (
    <>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <div className="mb-3">
          <label className="d-block mb-2">
            Code de vérification <span className="text-danger">*</span>
          </label>
          <div className="d-flex justify-content-center gap-2 mb-3">
            {verificationCode.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (codeInputRefs.current[index] = el)}
                type="text"
                className="form-control text-center"
                maxLength={1}
                value={digit}
                onChange={(e) => onCodeChange(index, e.target.value)}
                onKeyDown={(e) => onCodeKeyDown(index, e)}
                onPaste={onCodePaste}
                style={{
                  width: "50px",
                  height: "50px",
                  fontSize: "1.5em",
                  fontWeight: "bold",
                }}
              />
            ))}
          </div>
          <div className="text-muted text-center" style={{ fontSize: "0.9em" }}>
            Un code de vérification a été envoyé à votre adresse email
          </div>
        </div>
      </CpntFormSectionContainer>

      <CpntFormSectionNavigation>
        {isVerifying ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <button
            type="button"
            className="btn btn-primary col-12"
            onClick={onVerifyCode}
            disabled={verificationCode.some((digit) => digit === "")}
          >
            Vérifier le code
          </button>
        )}
      </CpntFormSectionNavigation>
    </>
  );
};

export default CpntCodeVerification;
